var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/components/internal/OnsiteMessageThemeWrapper/OnsiteMessageThemeWrapper.jsx";

/* eslint-disable no-confusing-arrow */
import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { token } from '@zillow/constellation';
import { getCustomTheme } from '../../../themes/ThemeUtils/getCustomTheme';

var themeCss = function themeCss(_ref) {
  var background = _ref.background,
      fontColor = _ref.fontColor,
      iconColor = _ref.iconColor;
  return css(["background:", ";h6,span{color:", ";}svg{color:", ";}", ""], token("colors." + background), token("colors." + fontColor), token("colors." + iconColor), background === 'backgroundDarkBlue' ? "button[class*='StyledTextButton'] {\n            color: #FFF !important;\n        }" : '');
};

var StyledDiv = styled.div.withConfig({
  displayName: "OnsiteMessageThemeWrapper__StyledDiv",
  componentId: "srrtc3-0"
})(["&.omp-theme-wrapper div{", "}"], themeCss);
export var OnsiteMessageThemeWrapper = function OnsiteMessageThemeWrapper(_ref2) {
  var children = _ref2.children,
      theme = _ref2.theme;

  var _getCustomTheme = getCustomTheme(theme),
      themeToRender = _getCustomTheme.themeToRender;

  if (themeToRender) {
    var _getCustomTheme2 = getCustomTheme(theme),
        _getCustomTheme2$them = _getCustomTheme2.themeToRender,
        background = _getCustomTheme2$them.background,
        fontColor = _getCustomTheme2$them.fontColor,
        iconColor = _getCustomTheme2$them.iconColor;

    return /*#__PURE__*/React.createElement(StyledDiv, {
      className: "omp-theme-wrapper",
      background: background,
      fontColor: fontColor,
      iconColor: iconColor,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 38,
        columnNumber: 13
      }
    }, children);
  }

  return null;
};
OnsiteMessageThemeWrapper.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,

  /**
   * The background, font & icon colors within the component. Currently there are 4
   * selectable themes 'backgroundBlue', 'backgroundDarkBlue', 'backgroundWhite' & 'blue200'.
   * */
  theme: PropTypes.oneOf(['backgroundBlue', 'backgroundDarkBlue', 'backgroundWhite', 'blue200'])
} : {};
OnsiteMessageThemeWrapper.defaultProps = {
  children: null,
  theme: null
};